import {
  ID__ATS_TYPE__NONE
} from '../../Definition';
import getAtsContextMapped from './getAtsContextMapped.fun';

/**
 * Updates the atsContext property of an entity with a new value.
 *
 * @prop {object} entity - The entity to update.
 * @prop {number} atsTypeId - The ATS type ID to update.
 * @prop {object} update - The new values to update.
 * @returns {object} The updated entity with atsContext property updated.
 * @example structure
 * Employer.atsContext = {
 *   [ATS_TYPE__ASHBY_ID]: {
 *     sourceId: 'ashbySourceId',
 *     userId: 'ashbyUserId',
 *     apiKey: 'ashbyApiKey'
 *   },
 *   [ATS_TYPE__GREENHOUSE_ID]: {
 *     sourceId: 'greenhouseSourceId',
 *     userId: 'greenhouseUserId',
 *     apiKey: 'greenhouseApiKey'
 *   }
 * }
 */
export default function getAtsContextUpdated({
  entity = {},
  atsTypeId = ID__ATS_TYPE__NONE,
  update = {}
}) {
  const CONTEXT__ATS = getAtsContextMapped({
    entity,
    atsTypeId
  });
  return {
    atsContext: {
      ...CONTEXT__ATS,
      [atsTypeId]: {
        ...CONTEXT__ATS[atsTypeId],
        ...update
      }
    }
  };
}